import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { Route, Switch, Redirect } from 'react-router-dom';
import ArchiveAcceptedContainer from './Accepted/ArchiveAcceptedContainer';
import ScoreCell from '../Table/ScoreCell/ScoreCell';
import { handleShowOffer, truncateText } from '../../helpers/utils';
import ArchiveSoldContainer from './Sold/ArchiveSoldContainer';
import { vehicleTypes } from '../../consts/vehicleTypes';

class ArchiveTablesContainer extends PureComponent {
  handleOfferDetails = (id, whichFolder) => {
    const { history, match } = this.props;
    const isTextNotSelected = window.getSelection().toString() === '';
    if (isTextNotSelected) {
      handleShowOffer(id, history, match, whichFolder);
    }
  }
  renderRow = (item) => {
    const { isMobile, vehicleType } = this.props;
    const formattedModel = truncateText(get(item, ['vehicle' ,'model']), 17, 'right');
    const formattedCategory = truncateText(get(item, ['vehicle' ,'category']), 17, 'right');
    const formattedArchivedDate = moment(get(item, 'archived')).format('DD/MM/YY HH:mm');

    const mobileCells = {
      [vehicleTypes.Motorbike]:[
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, 'brand')} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
      [vehicleTypes.AgriculturalMachine]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle','brand_name'])} {formattedCategory}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'production_year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ],
      [vehicleTypes.Camper]: [
        <td key="mobile-cells" className="cell-mobile-wrapper">
          <div>
            <span>{get(item, ['vehicle','body_mark'])} {formattedModel}</span>
          </div>
          <div>
            <span>{get(item, ['vehicle', 'production_year'])}, {get(item, 'hash_id')}</span>
          </div>
        </td>
      ]
    };

    const desktopCells = {
      [vehicleTypes.Motorbike]:[
        <td key="brand">{get(item, ['vehicle', 'brand_name'])}</td>,
        <td key="model" className="cell-model">
          {formattedModel}
        </td>,
        <td key="year">{get(item, ['vehicle', 'year'])}</td>,
        <td key="id" className="cell-owners">{get(item, 'hash_id')}</td>,
        <td key="value">{get(item, 'value')}</td>,
        <td key="archived">{formattedArchivedDate}</td>,
      ],
      [vehicleTypes.AgriculturalMachine]:[
        <td key="brand">{get(item, ['vehicle', 'brand_name'])}</td>,
        <td key="model" className="cell-model">
          {formattedCategory}
        </td>,
        <td key="year">{get(item, ['vehicle', 'production_year'])}</td>,
        <td key="id" className="cell-owners">{get(item, 'hash_id')}</td>,
        <td key="value">{get(item, 'value')}</td>,
        <td key="archived">{formattedArchivedDate}</td>,
      ],
      [vehicleTypes.Camper]:[
        <td key="body_mark">{get(item, ['vehicle', 'body_mark'])}</td>,
        <td key="model" className="cell-model">
          {formattedModel}
        </td>,
        <td key="year">{get(item, ['vehicle', 'year'])}</td>,
        <td key="id" className="cell-owners">{get(item, 'hash_id')}</td>,
        <td key="value">{get(item, 'value')}</td>,
        <td key="archived">{formattedArchivedDate}</td>,
      ],
  };

    return [
      <ScoreCell
        key="score"
        score={get(item, ['vehicle', 'score'])}
        hideImage
      />
    ].concat(isMobile ? mobileCells[vehicleType] : desktopCells[vehicleType]);
  }
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Redirect from="/dashboard/archive" exact to="/dashboard/archive/accepted" />
        <Route exact path={`${match.url}/accepted`}>
          <ArchiveAcceptedContainer
            handleShowOffer={this.handleOfferDetails}
            renderRow={this.renderRow}
          />
        </Route>
        <Route exact path={`${match.url}/sold`}>
          <ArchiveSoldContainer
            handleShowOffer={this.handleOfferDetails}
            renderRow={this.renderRow}
          />
        </Route>
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: get(state, ['vehicleType', 'vehicleType']),

  };
};

ArchiveTablesContainer.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes))
};

export default connect(mapStateToProps)(ArchiveTablesContainer);
